const { getNumber } = require('../utils');
const { Table } = require ('antd');
export default [
    {
        title: '机器人',
        type: 'string',
        dataIndex: 'name',
        key: 'name',
        width: '7%',
        sorter: (a, b) => getNumber(a.name) - getNumber(b.name),
        defaultSortOrder: 'ascend',
        // editable: true,
    },
    {
        title: '步骤',
        type: 'number',
        dataIndex: 'step',
        key: 'step',
        width: '6%',
        sorter: (a, b) => a.step - b.step,
        editable: true,
    },
    {
        title: '状态',
        type: 'string',
        dataIndex: 'status',
        key: 'status',
        width: '7%',
        editable: true,
    },
    {
        title: '账户',
        type: 'string',
        dataIndex: 'belong',
        key: 'belong',
        width: '6%',
        sorter: (a, b) => getNumber(a.belong) - getNumber(b.belong),
        editable: true,
    },
    {
        title: '报错',
        type: 'string',
        dataIndex: 'error',
        key: 'error',
        width: '30%',
        ellipsis: true,
        editable: true,
    },
    {
        title: 'IP',
        type: 'string',
        dataIndex: 'ip',
        key: 'ip',
        width: '8%',
        ellipsis: true,
        editable: true,
    },
    Table.EXPAND_COLUMN,
    {
        title: 'WIFI',
        type: 'string',
        dataIndex: 'wifi',
        key: 'wifi',
        width: '10%',
        ellipsis: true,
        editable: true,
    },
    Table.SELECTION_COLUMN,
    {
        title: '账号',
        type: 'string',
        dataIndex: 'account',
        key: 'account',
        width: '9%',
        sorter: (a, b) => Number(a['account']) - Number(b['account']),
        editable: true,
    },
];